module.exports = __webpack_public_path__ + "img/site-top.8605a7e5.jpg";